import { StoredHazmat } from "../models/stored-orders/stored-hazmat";
import { IStoredMapper } from "./stored-mapper";
import { HazmatViewModel } from "src/app/view-models/hazmat.view-model";

/**
 * Mapping class that maps between Hazmat view model and database StoredHazmat.
 */
export class HazmatMapper implements IStoredMapper<HazmatViewModel, StoredHazmat> {
	/**
	 * Maps a Hazmat to a StoredHazmat.
	 * @param hazmat The hazmat data to convert.
	 * @returns A StoredHazmat object.
	 */
	public ToStored(hazmat: HazmatViewModel): StoredHazmat {
		return {
			IsPlacardRequired: hazmat.IsPlacardRequired,
			UNNumber: hazmat.UNNumber,
			Description: hazmat.Description,
			ClassNumber: hazmat.ClassNumber,
			PackageGroup: hazmat.PackageGroup,
			EmergencyPhoneNumber: hazmat.EmergencyPhoneNumber
		};
	}

	/**
	 * Maps a StoredHazmat to a Hazmat.
	 * @param storedHazmat The stored hazmat data to convert.
	 * @returns A Hazmat object.
	 */
	public FromStored(storedHazmat: StoredHazmat): HazmatViewModel {
		return {
			IsPlacardRequired: storedHazmat.IsPlacardRequired,
			UNNumber: storedHazmat.UNNumber,
			Description: storedHazmat.Description,
			ClassNumber: storedHazmat.ClassNumber,
			PackageGroup: storedHazmat.PackageGroup,
			EmergencyPhoneNumber: storedHazmat.EmergencyPhoneNumber
		};
	}
}